import React, { useState, useEffect, useContext } from 'react'
import DataRow from '../../../components/subComponents/DataRow'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { GlobalContext } from '../../../services/context'
import { getArchivePdfContracts } from '../../../services/apiHelper'

const ContractDetailWidget = ({ contractData, contractHeaders, status, company_id, contract_id, contract_doc_link, isVoided, growerAndResellerSAP, resellerAndReceiverId, contract_state }) => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const [contractState, setContractState] = useState('')
  const [ archivePdfContractsURL, setarchivePdfContractsURL] = useState('')
  let dataEntries = Object.entries(contractData)
  let data = []

  useEffect(() => {
    if(contract_state)
      setContractState(contract_state)
  },[contract_state])

  useEffect(() => {
    if(contractState)
      getArchivePdfContracts(contract_id)?.then(response => {
        if (response) {
          setarchivePdfContractsURL(response.res||null)
        }
      })
  },[contractState, contract_id])

  dataEntries.forEach(entry => {
    let title = contractHeaders
      .filter(header => header[1] === entry[0])
      .flat()
    data.push({ title: title[0], value: entry[1] })
  })

  let content = status ? <TableStatus status={status} /> : null
  if (!content && data.length) {
    content = (
      <>
        <DataRow data={data.slice(0, 3)} data-testid='dataRow'/>
        <div className='bb1-s-lightgray hide-tablet' />
        <DataRow data={data.slice(3, 6)} growerAndResellerSAP={growerAndResellerSAP} resellerAndReceiverId={resellerAndReceiverId}/>
        <div className='bb1-s-lightgray hide-tablet'/>
        <DataRow data={data.slice(6, data.length)} growerAndResellerSAP={growerAndResellerSAP}/>
      </>
    )
  }

  const goToContractPDFView = () => {
    const newTitle = `${contractData.year} : ${contractData.grower_name} to ${contractData.reseller}`
    const new_contract_id = contractData.new_contract_id
    const detailView= {
      previous: '',
      title: newTitle,
      new_contract_id: new_contract_id
    }
    trackEvent('view_contract_pdf_clicked', { contractId: contract_id })
    dispatch({ type: 'GO_TO_CONTRACT_PDF_VIEW', payload: { company_id, contractDetails: { contract_id, contract_doc_link }, detailView: detailView } })
  }

  const downloadFile = () => {
    getArchivePdfContracts(contract_id)
      .then(response => {
        if (response) {
          const contract_doc_link = response.res
          const newTitle = `${contractData.year} : ${contractData.grower_name} to ${contractData.reseller}`
          const new_contract_id = contractData.new_contract_id
          const detailView= {
            previous: '',
            title: newTitle,
            new_contract_id: new_contract_id
          }
          trackEvent('view_contract_pdf_clicked', { contractId: contract_id })
          dispatch({ type: 'GO_TO_CONTRACT_PDF_VIEW', payload: { company_id, contractDetails: { contract_id, contract_doc_link }, detailView: detailView } })
        }
      })
  }

  const buttonRender = (
    <div className="tar">
      {isVoided ? <div><Button text={'View contract PDF'} onClick={e=>downloadFile(archivePdfContractsURL)} /></div> : <div><Button text={'View contract PDF'} onClick={goToContractPDFView} customClassName="ml10"/></div> }
      {contractState === 'completed' || contractState === 'amendment_completed' ? <div><Button text={'View signed contract PDF'} onClick={e=>downloadFile(archivePdfContractsURL)} /></div>: null }
    </div>
  )
  
  return (
    <Widget
      dataTestId='contractDetailWidget'
      title={'Contract details'}
      button={buttonRender}
    >
      <div >
        {content}
      </div>
      
    </Widget>
  )
}

export default ContractDetailWidget